// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__vojGq","loader":"Loader_loader__+lRPl","spinner":"Loader_spinner__iDFIv"};